'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import CurriculumManagementContent from './components/CurriculumManagementContent';

export default function CurriculumManagementPage() {
  return (
    <AppLayout role="admin" campusMode="pro">
      <CurriculumManagementContent />
    </AppLayout>
  );
}
